import { render, staticRenderFns } from "./DashboardArin.vue?vue&type=template&id=2bbcb2ec&scoped=true&"
import script from "./DashboardArin.vue?vue&type=script&lang=js&"
export * from "./DashboardArin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcb2ec",
  null
  
)

export default component.exports